import { useMemo } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { format } from "date-fns";
import { SmsRule } from "~/core/resources/smsApi";
import { DataTable } from "~/components/DataTable/DataTable";
import { SmsTitleContent } from "~/components/SmsTitleContent";
import { hexToRgbaString } from "~/utils/colorUtil";

const AppointmentInfo = styled.div`
  display: flex;
  font-weight: bold;

  span:first-of-type {
    &::after {
      font-size: 10px;
      margin: 0 5px;
      content: "|";
    }
  }
`;

const DepartmentName = styled.div`
  max-width: 105px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type ImmediateSmsPreviewTableProps = {
  appointment: any;
  smsRules: SmsRule[];
};

export const ImmediateSmsPreviewTable = ({
  appointment,
  smsRules,
}: ImmediateSmsPreviewTableProps) => {
  const groupId = "group";

  const schema = useMemo(
    () => ({
      rows: {
        style: () => {
          return css`
            background: ${hexToRgbaString("#EDEFF1", 0.4)};
          `;
        },
      },
      rowGroup: {
        groupId: groupId,
        groupKey: () => groupId,
        groupData: () => Object.assign(appointment, { group: groupId }),
        component: (attr: any) => {
          const { item } = attr;
          const startAt = item.startAt
            ? format(new Date(item.startAt), "yyyy-MM-dd HH:mm")
            : "";
          return (
            <div>
              <AppointmentInfo>
                <span>예약정보</span>
                <span>{startAt} </span>
                <div style={{ display: "flex" }}>
                  <DepartmentName>
                    {item.department?.category?.name} - &nbsp;
                  </DepartmentName>
                  <DepartmentName>{item.department?.name}</DepartmentName>
                </div>
              </AppointmentInfo>
            </div>
          );
        },
      },
      columns: [
        {
          id: "sendOption",
          name: "전송옵션",
          value: () => "즉시발송",
          style: {
            minWidth: "100px",
          },
        },
        {
          id: "title",
          name: "제목/내용",
          component: (attr: any) => {
            const { item } = attr;
            return <SmsTitleContent item={item} />;
          },
          grow: true,
        },
      ],
    }),
    []
  );

  return (
    <DataTable data={smsRules ?? []} schema={schema} expanded={[groupId]} />
  );
};
